import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin, isLoggedIn } from '../../api/client';
import './Admin.css';

export default function AdminLogin() {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isLoggedIn()) {
      navigate('/admin/trainings', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');
    setLoading(true);

    try {
      await adminLogin(
        username.trim(),
        password
      );

      navigate('/admin/trainings');
    } catch (err) {
      setError(err.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adm">
      <div className="adm-login-wrap">
        <div className="adm-login-card">

          <h1 className="adm-login-title">
            Admin Login
          </h1>

          <p className="adm-login-sub">
            Manage Trainings, Portfolio &amp; Career content
          </p>

          {error && (
            <div className="adm-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>

            <div className="adm-field">
              <label htmlFor="username">
                Username
              </label>

              <input
                id="username"
                type="text"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="adm-field">
              <label htmlFor="password">
                Password
              </label>

              <input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              className="adm-btn"
              type="submit"
              disabled={loading}
            >
              {loading ? 'Signing in…' : 'Sign In'}
            </button>

          </form>

        </div>
      </div>
    </div>
  );
}